import { EntityTypes } from './enums/entityTypes';
import { OrgTypes } from './enums/orgTypes';

export interface Org {
  orgId: string;
  entityType: EntityTypes.org;
  orgName: string;
  orgType: OrgTypes;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
  coordinates?: Coordinates;
  website: string;
  linkedInURL?: string;
  created: number;
  lastUpdated: number;
  profileURI: string;
  contactPhone?: string;
  contactEmail?: string;
  orgHash?: string;
  featureFlags?: FeatureFlags;
}

export interface FeatureFlags {
  demo?: boolean;
}

export interface Coordinates {
  latitude: number;
  longitude: number;
}